import React from 'react';
import { styled, Button as MuiButton } from '@mui/material';
import clsx from 'clsx';
import { buttonClasses } from '../style';
import { getIconButtonStyle, generateIconButtonClassnames } from './style';
import { filterOtherNativeProps } from '../util';
import IconLoading from '../IconLoading';
const IconButtonBase = React.forwardRef((props, ref) => {
    const { children, onClick, className, autoFocus, sx, classes, fullWidth, htmlType, loading, autoLoading, ...restProps } = props;
    const restNativeProps = filterOtherNativeProps(restProps);
    return (React.createElement(MuiButton, { ref: ref, disableRipple: true, className: className, onClick: onClick, autoFocus: autoFocus, classes: {
            startIcon: buttonClasses.startIcon,
            endIcon: buttonClasses.endIcon,
            focusVisible: buttonClasses.focusVisible,
        }, sx: sx, fullWidth: fullWidth, type: htmlType, ...restNativeProps }, loading ? (React.createElement(IconLoading, { className: buttonClasses.loadingIcon })) : (children)));
});
const StyledIconButton = styled(IconButtonBase)((props) => {
    const { theme } = props;
    return getIconButtonStyle(theme, props);
});
const RefIconButton = React.forwardRef((props, ref) => (React.createElement(StyledIconButton, { ...props, ref: ref })));
const IconButton = React.forwardRef((props, ref) => {
    const { children, onClick, className, type, size, disabled, autoFocus, sx, fullWidth, ...restProps } = props;
    return (React.createElement(RefIconButton, { ref: ref, className: clsx(generateIconButtonClassnames(), className), onClick: onClick, size: size, type: type, disabled: disabled, autoFocus: autoFocus, sx: sx, fullWidth: fullWidth, ...restProps }, children));
});
export { IconButton };
